import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import React, { useRef } from "react";

interface Props {
  onFileSelected: (file: File) => void;
  acceptedExtensions?: string;
  title?: string;
}

const LocalFilePicker = ({ onFileSelected, acceptedExtensions = ".xlsx,.xls", title = "Upload file" }: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelected(file);
    }
    // Reset input value to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedExtensions}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <IconButton
        color="primary"
        size="large"
        title={title}
        onClick={handleButtonClick}
      >
        <FontAwesomeIcon
          icon={faFileUpload}
          size="2xl"
        />
      </IconButton>
    </>
  );
};

export default LocalFilePicker;
